import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Club({club}) {
    const { t } = useTranslation()
    const imageUrl = club?.bannerMarketplace || "/images/bannerclub.jpg"
    const [avatarError, setAvatarError] = useState(false)

    return (
        <div className="club-market-card">
            <Link to={`/${t("url.marketplace.clubs")}/${club?.url}`} className="club-market-card-image-link">
                <div className="club-market-card-image" style={{backgroundImage: `url(${imageUrl})`}}>
                </div>
            </Link>
            <div className="club-market-card-body">
                <div className="club-market-card-header">
                    {club?.avatar && !avatarError
                        ? <img src={club?.avatar} alt="" className="club-market-card-avatar" onError={() => setAvatarError(true)} />
                        : <div className="club-market-card-avatar-placeholder"><i className="fas fa-building"></i></div>
                    }
                    <div className="club-market-card-info">
                        <Link to={`/${t("url.marketplace.clubs")}/${club?.url}`} className="club-market-card-title-link">
                            <h3 className="club-market-card-title">{club?.name}</h3>
                        </Link>
                        {club?.sports?.length > 0 &&
                            <div className="club-market-card-sports">
                                {club.sports.slice(0, 3).map((sport, i) => (
                                    <span key={i} className="club-market-card-sport-tag">
                                        {t('sports.' + sport)}
                                    </span>
                                ))}
                                {club.sports.length > 3 &&
                                    <span className="club-market-card-sport-tag more">+{club.sports.length - 3}</span>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div className="club-market-card-footer">
                    <Link to={`/${t("url.marketplace.clubs")}/${club?.url}`} className="club-market-card-btn">
                        {t("global.moreInfo")}
                        <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    )
}
